export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const MOBILE_REGEX = /^[0-9\s()+-]*$/;
export const NO_SPACE_REGEX = /^\S*$/;
